import { createSelector } from '@ngrx/store';
import find from 'lodash/find';

import { getCitation } from './get.citations';
import { UnnumberedCitation } from '../../models';

export const getUnnumberCitationToDelete = createSelector(
  [getCitation],
  ({
    unnumbered_references,
    deletedUnnumberedCitationId,
  }): UnnumberedCitation | null =>
    deletedUnnumberedCitationId &&
    find(unnumbered_references, { citationId: deletedUnnumberedCitationId })
);
